import { render, staticRenderFns } from "./singlechoice.vue?vue&type=template&id=e0a9ebc8&scoped=true"
import script from "./singlechoice.vue?vue&type=script&lang=js"
export * from "./singlechoice.vue?vue&type=script&lang=js"
import style0 from "./singlechoice.vue?vue&type=style&index=0&id=e0a9ebc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a9ebc8",
  null
  
)

export default component.exports